<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA; padding-bottom: 2%; min-height: 100vh;">
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-4 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          แก้ไขข้อมูล Service
        </span>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-4 mr-2 action-top-btn">
        <v-btn
          outlined
          color="primary"
          class="ml-2 mr-2"
          @click="promtDialog = true"
        >
          <span class="">
            ยกเลิก
          </span>
        </v-btn>
        <v-btn
          color="primary"
          class="ml-2 white--text"
          elevation="0"
          style="margin-right: 0px;"
          :disabled="(!isChange) || (isChange && !allowSave)"
          @click="dialogConfirmSubmitData = true"
        >
          <span class="ra-text-in-button">
            บันทึกข้อมูล
          </span>
        </v-btn>
      </v-col>
    </v-row>
    <!-- isChange {{isChange}} -->
    <!-- <br> {{ approvers}} <br> -->
    <!-- <br>{{this.serviceName}} | {{this.originDataSource.serviceName}} = {{this.serviceName !== this.originDataSource.serviceName}}
    <br>{{this.note}} | {{this.originDataSource.comment}} = {{this.note !== this.originDataSource.comment}}
    <br>{{this.urlName}} | {{this.originDataSource.url}} = {{this.urlName !== this.originDataSource.url}}
    <br>{{this.selectGroupCompany}} | {{this.originDataSource.groupCompanyId}} = {{this.selectGroupCompany !== this.originDataSource.groupCompanyId}}
    <br>{{this.selectCompany}} | {{this.originDataSource.companyId}} = {{this.selectCompany !== this.originDataSource.companyId}}
    <br>{{this.selectType}} | {{this.originDataSource.serviceForOrg.type}} = {{this.selectType.toString() !== this.originDataSource.serviceForOrg.type.toString()}}
    <br>{{this.selectOrgChart}} | {{this.originDataSource.serviceForOrg.orgId}} = {{this.selectOrgChart !== this.originDataSource.serviceForOrg.orgId}} -->
    <OverlayLoading :loading="isInitData" />
    <v-card height="auto" min-height="82vh" class="pt-7 pb-7" >
      <v-container fluid pa-0 >
          <v-row align="center" justify="center" >
          <div class="update-chart-full pt-1 pb-4 rounded-0" style="min-width:50vw; width:50vw; max-width:90vw;">
            <div class="text-left">
              <span class="blue--text text--darken-4 font-weight-bold mr-5 text-title-content">ข้อมูล Service</span>
              <span class="grey--text text-darken-4 mt-1 mb-1">(</span><span class="red--text text-darken-4 mt-1 mb-1">* </span><span class="grey--text text-darken-4 mt-1 mb-1">กรุณากรอกข้อมูลให้ครบถ้วน)</span>
            </div>
            <v-divider class="mt-1 mb-4"/>
            <div class="text-center mt-1" justify="start">
              <v-row class="mb-0" align="center" style="margin-top: 0px;">
                <v-col cols="12" lg="6" md="6" class="text-left" style="margin-top: -5px;">
                  <span class="grey--text text-darken-4 mt-1 mb-1">ชื่อ Service</span><br>
                  <v-text-field
                    v-model="serviceName"
                    outlined
                    dense
                    class="mt-1"
                    placeholder="กรุณาระบุชื่อ Service"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="6" md="6" class="text-left" style="margin-top: -5px;">
                  <span class="grey--text text-darken-4 mt-1 mb-1">URL website</span><br>
                  <v-text-field
                    v-model="urlName"
                    outlined
                    dense
                    class="mt-1"
                    placeholder="กรุณากรอกรายละเอียด Service"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: 2px;">
                <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: -5px;" align-self="end">
                  <span class="grey--text text-darken-4 mt-1 mb-1">Token</span><br>
                  <v-text-field
                    v-model="token"
                    outlined
                    dense
                    readonly
                    background-color="#FAFAFA"
                    v-if="token"
                  >
                    <template slot="append-outer">
                      <v-tooltip bottom style="cursor: pointer;">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="ra-border-button"
                            style="margin-top: -8px;"
                            height="40"
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            icon
                            :disabled="false"
                            @click="copyToken"
                          >
                          <v-icon color="gray" >mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span class="label-table-action">คัดลอก Token</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                  <span v-else class="black--text mt-1 mb-1">-</span>
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: -5px;">
                <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: -5px;">
                  <span class="grey--text text-darken-4 mt-1 mb-1">รายละเอียด  Service</span><br>
                  <v-textarea
                    v-model="note"
                    outlined
                    dense
                    rows="2"
                    class="mt-1"
                    placeholder="กรุณากรอกรายละเอียด Service"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <div class="text-left mt-6">
                <span class="blue--text text--darken-4 font-weight-bold mr-5 text-title-content ">ข้อมูลบริษัท</span>
                <span class="grey--text text-darken-4 mt-1 mb-1">(กรุณากรอกข้อมูลให้ครบถ้วน)</span>
              </div>
              <v-divider class="mt-1 mb-4"/>
              <v-row class="mb-0 mt-2" align="center">
                <v-col cols="12" lg="6" md="6" class="text-left" style="margin-top: -5px;">
                  <!-- {{itemGroupCompany}} -->
                  <span class="grey--text text-darken-4 mt-1 mb-1">เครือบริษัท</span><br>
                  <!-- <span class="black--text mt-1 mb-1">{{ dataSource.groupName || '-' }}</span> -->
                  <v-autocomplete
                    v-model="selectGroupCompany"
                    class="mt-1"
                    :items="itemGroupCompany"
                    item-text="groupCompanyNameTh"
                    item-value="_id"
                    outlined
                    dense
                    placeholder="เลือกเครือ"
                  />
                </v-col>
                <v-col cols="12" lg="6" md="6" class="text-left">
                  <span class="grey--text text-darken-4 mt-1 mb-1">บริษัท</span><br>
                  <!-- <span class="black--text mt-1 mb-1">{{ dataSource.companyName || '-' }}</span> -->
                  <v-autocomplete
                    v-model="selectCompany"
                    :items="itemCompany"
                    item-text="companyFullNameTh"
                    item-value="_id"
                    outlined
                    dense
                    :placeholder="selectGroupCompany? itemCompany.length==0? 'ไม่มี':'เลือกบริษัท':'กรุณาเลือกเครือบริษัทก่อน'"
                    :readonly="!checkCompany"
                    :append-icon="checkCompany? itemCompany.length == 0? '':'$dropdown':''"
                  />
                </v-col>
              </v-row>
              <v-row class="mb-0 mt-2" align="center">
                <v-col cols="12" lg="6" md="6" class="text-left">
                  <span class="grey--text text-darken-4 mt-1 mb-1">ประเภทงาน</span><br>
                  <v-autocomplete
                    v-model="selectType"
                    :items="sectionList"
                    item-text="name"
                    item-value="section"
                    outlined
                    dense
                    :placeholder="selectCompany? 'เลือกประเภทงาน':'กรุณาเลือกบริษัทก่อน'"
                    :append-icon="selectCompany? '$dropdown':''"
                    :readonly="!selectCompany"
                  />
                </v-col>
                <v-col cols="12" lg="6" md="6" class="text-left">
                  <span class="grey--text text-darken-4 mt-1 mb-1">สายบังคับบัญชา</span><br>
                  <v-autocomplete
                    v-model="selectOrgChart"
                    :items="itemOrgChart"
                    item-text="orgChartName"
                    item-value="_id"
                    outlined
                    dense
                    :placeholder="selectType? selectType!=='ทั้งหมด'? itemOrgChart.length == 0? 'ไม่มี':`เลือก${selectType}`:'ทั้งหมด':'กรุณาเลือกประเภทก่อน'"
                    :append-icon="selectType=='ทั้งหมด' || itemOrgChart.length == 0? '':'$dropdown'"
                    :readonly="!selectType || (selectType=='ทั้งหมด' || itemOrgChart.length == 0)"
                  />
                </v-col>
              </v-row>
              <v-row class="mb-0" align="center" style="margin-top: 10px;">
                <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: 5px;">
                  <div class="d-flex">
                    <span class="blue--text text--darken-4 font-weight-bold mr-5 text-title-content">ข้อมูลผู้อนุมัติ</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      elevation="0"
                      class=""
                      right
                      top
                      text
                      small
                      @click="openDialogAddAprover('add', '', '')"
                      v-if="approvers.length>0"
                    >
                      <v-icon left size="14px">
                        mdi-plus
                      </v-icon>
                      <span class="blue--text text--darken-2 text-title-content ">เพิ่มผู้อนุมัติ</span>
                    </v-btn>
                  </div>
                  <v-divider class="mt-1 mb-4"/>
                </v-col>
              </v-row>
              <div v-if="approvers.length==0">
              <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
              <br>
              <span class="black--text text-darken-4 mt-1 mb-1">ยังไม่มีข้อมูลผู้อนุมัติ</span>
              <br><br>
              <span class="grey--text text-darken-4 mt-1 mb-1">คลิกที่ปุ่มด้านล่างนี้เพื่อเพิ่มผู้อนุมัติ</span>
              <br>
              <v-btn
                color="primary"
                elevation="0"
                class="mt-4"
                right
                bottom
                @click="openDialogAddAprover('add', '', '')"
              >
                <v-icon left size="14px">
                  mdi-plus
                </v-icon>
                เพิ่มผู้อนุมัติ
              </v-btn>
              </div>
              <v-row class="mb-0" align="center" style="margin-top: -10px;"
                v-if="approvers.length"
              >
                <v-col cols="12" lg="12" md="12" class="text-left" style="margin-top: 5px;"
                  v-for="(item, index) in approvers"
                  :key="item.approverNo"
                >
                  <v-card
                      class="user-data-panel"
                      style="margin-top: -14px;"
                      outlined
                    >
                    <v-row class="pl-1 ml-0 mr-0 pr-1 pt-0 user-data-panel">
                      <!-- <v-col cols="2"> -->
                        <v-card flat outlined class="ra-head-text-gray blue--text text--darken-3 pl-1 pr-1 mt-1 mb-1" height="25">ลำดับที่ {{index+1}}</v-card>
                      <!-- </v-col> -->
                      <v-spacer></v-spacer>
                      <!-- <v-col cols="2"> -->
                        <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            rounded
                            color="#FFB300"
                            dark
                            icon
                            small
                            width="25"
                            height="25"
                            class="ra-border-button mt-1 "
                            @click="openDialogAddAprover('edit', item, index)"
                          >
                          <v-icon color="#3776E9" small>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>
                        <span class="label-table-action">แก้ไขข้อมูล ผู้อนุมัติ</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            rounded
                            color="#FFB300"
                            dark
                            icon
                            small
                            width="25"
                            height="25"
                            class="ra-border-button mt-1  ml-2"
                            @click="removeApprover(item)"
                          >
                          <v-icon color="error" small>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span class="label-table-action">ลบ ผู้อนุมัติ</span>
                      </v-tooltip>
                      <!-- </v-col> -->
                    </v-row>
                    <v-row class="pl-1 pr-1 pt-0">
                      <v-col cols="12" sm="2" md="2" lg="2" class="">
                        <v-avatar
                          class="ml-3 mt-0"
                          :size="$vuetify.breakpoint.name !== 'lg'? '70':'70'"
                          rounded
                        >
                        <v-img
                          cover
                          :lazy-src="require('@/assets/icons/no_user.png')"
                          :src="item.userImg? item.userImg : require('@/assets/icons/no_user.png')"
                        >
                        </v-img>
                        </v-avatar>
                      </v-col>
                      <v-col cols="12" sm="10" md="10" lg="10" style="margin-top: -10px; margin-bottom: -10px;">
                        <v-row class="">
                          <v-col cols="12" lg="5" md="5" sm="5" class="ma-0 pb-0">
                            <span class="ra-head-text-gray">รหัสพนักงาน: </span>
                            <span class="ra-head-text black--text">{{ item.employeeId }}</span>
                          </v-col>
                          <v-col cols="12" lg="7" md="7" sm="7" class="ma-0 pb-2">
                            <span class="ra-head-text-gray">ชื่อ - นามสกุล: </span>
                            <span class="ra-head-text black--text">{{ item.approverName }}</span>
                          </v-col>
                          <v-col cols="12" lg="5" md="5" sm="5" class="ma-0 pb-0">
                            <span class="ra-head-text-gray">อีเมล: </span>
                            <span class="ra-head-text black--text">{{ item.email || item.emailOneId }}</span>
                          </v-col>
                          <v-col cols="12" lg="7" md="7" sm="7" class="ma-0 pb-2">
                            <span class="ra-head-text-gray">ตำแหน่ง: </span>
                            <span class="ra-head-text black--text">{{ item.position }}</span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-row>
      </v-container>
    </v-card>
    <DialogAddAprover @pressAddApprover="addApprover($event)" @pressChangeApprover="changeApprover($event)"/>
    <v-dialog v-model="dialogConfirmSubmitData" max-width="344px" persistent>
      <v-card >
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการบันทึกข้อมูลใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px;">คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูล</span>
        </v-card-text>
        <v-card-actions class="justify-center mt-0 pb-5">
           <v-btn
              color="primary"
              outlined
              class="head-search-button mr-4"
              width="90"
              @click="dialogConfirmSubmitData = false"
            >
            ยกเลิก
            </v-btn>
            <v-btn
              color="primary"
              class="head-search-button ml-4 white--text text--lighten-4"
              elevation="0"
              width="90"
              @click="submitData()"
            >
            ยืนยัน
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="promtDialog"
      persistent
      max-width="350"
      max-height="500"
      style="z-index: 9999"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #3776E9;">
            ต้องการออกจากหน้านี้ใช่ไหม
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            ข้อมูลของคุณยังไม่ถูกบันทึก <br> คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้
          </span>
        </v-card-subtitle>
        <div class="justify-center">
          <v-btn
            color="primary"
            class="head-search-button ml-10 mt-2 mb-2 white--text text--lighten-4"
            width="275"
            @click="goBack()"
          >
          ตกลง ฉันจะออกจากหน้านี้
          </v-btn>
          <v-btn
            color="primary"
            class="ml-10 mt-2 mb-2 "
            width="275"
            outlined
            @click="promtDialog = false"
          >
          ไม่ ฉันจะอยู่ต่อหน้านี้
          </v-btn>
        </div>
        <v-card-actions class="">
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      centered
      elevation="1"
      color="#FAFAFA"
      app
      class="show-service"
    >
      <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: black;">
        copy to clipboard
      </span>
    </v-snackbar>
  </div>
</template>

<script>
import {
  editService,
  // getCompanySelector,
  // getChartPickerSelector,
  getServiceById,
  getSelectorGroup,
  searchLeader,
  hostImageUrlv3
} from '@/API/API'
import swal from 'sweetalert'
import DialogAddAprover from '../_dialog/dialogAddApprover'
import { EventBus } from '@/EventBus'
import OverlayLoading from '@/components/_template/OverlayLoading.vue'

export default {
  components: {
    DialogAddAprover,
    OverlayLoading
  },
  name: 'showServiceDetail',
  data () {
    return {
      dialogShow: false,
      promtDialog: false,
      serviceName: '',
      serviceId: '',
      urlName: '',
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      reqType: 'Service',
      selectedService: '',
      note: '',
      approvers: [],
      itemsReqType: [],
      itemsServiceList: [],
      itemsApprovers: [],
      itemGroupCompany: [],
      itemCompany: [],
      itemOrgChart: [],
      token: 'xxxxx',
      dataSource: [],
      originDataSource: [],
      allCompany: [],
      selectGroupCompany: '',
      selectCompany: '',
      selectType: '',
      selectOrgChart: '',
      img: '',
      positionData: [{
        positionName: '',
        companyName: ''
      }],
      chartPickerSelector: [],
      sectionList: [],
      // sectionList: ['ทั้งหมด', 'สายงาน', 'ฝ่ายงาน', 'ส่วนงาน', 'หน่วยงาน', 'กลุ่มงาน'],
      sectionNumberList: [],
      dialogConfirmSubmitData: false,
      isInitData: true,
      snackbar: false
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  async created () {
    this.serviceId = this.$route.params.id
    await this.initDataService(this.$route.params.id)
    // this.getCompanySelector()
    await this.getGroupCompanySelector()
  },
  computed: {
    checkCompany () { return !!this.selectGroupCompany.length },
    allowSave () {
      var result = (this.serviceName && this.urlName && this.note && this.selectType) &&
      (this.selectGroupCompany && this.selectCompany && this.selectType && ((this.selectType === 'ทั้งหมด' && this.selectOrgChart === '') || (this.selectType !== 'ทั้งหมด' && this.selectOrgChart !== ''))) &&
      this.approvers.length > 0
      return result
    },
    isChange () {
      // var result = true
      var result = this.serviceName !== this.originDataSource.serviceName ||
                    this.note !== this.originDataSource.comment ||
                    this.urlName !== this.originDataSource.url ||
                    this.selectGroupCompany !== this.originDataSource.groupCompanyId ||
                    this.selectCompany !== this.originDataSource.companyId ||
                    this.selectType.toString() !== (this.serviceForOrg ? this.originDataSource.serviceForOrg.type.toString() : '') ||
                    this.selectOrgChart !== this.originDataSource.serviceForOrg.orgId ||
                    (JSON.stringify(this.approvers.map(({ userId }) => (userId))) !== JSON.stringify(this.originDataSource.approver.map(({ userId }) => (userId))))
      return result
    },
    alreadyUser () {
      return this.approvers.map(({ userId }) => (userId))
    }
  },
  watch: {
    async selectGroupCompany () {
      // this.selectCompany = ''
      // await this.getCompanySelector()
      // if (this.isInitData) this.selectCompany = this.dataSource.companyId
      if (!this.isInitData) {
        this.selectCompany = ''
        await this.getCompanySelector()
      }
    },
    async selectCompany () {
      // this.selectType = ''
      // await this.getSectionSelector()
      // if (this.isInitData) this.selectType = this.dataSource.serviceForOrg.type
      if (!this.isInitData) {
        this.selectType = ''
        await this.getSectionSelector()
      }
    },
    async selectType () {
      // this.selectOrgChart = ''
      // await this.getChartSelector()
      // if (this.isInitData) this.selectOrgChart = this.dataSource.serviceForOrg.orgId
      if (!this.isInitData) {
        this.selectOrgChart = ''
        await this.getChartSelector()
      }
    }
  },
  methods: {
    goBack () {
      this.$router.push('/settingservices')
    },
    copyToken () {
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        event.originalEvent?.clipboardData ||
        navigator.clipboard
      clipboardData.writeText(this.token)
      this.snackbar = true
    },
    async initDataService (id) {
      this.dataSource = []
      this.approvers = []
      this.loadingInit = true
      this.isInitData = true
      const payload = { serviceId: id }
      try {
        const res = await getServiceById(this.$store.state.token, payload)
        if (res.success) {
          // console.log(res)
          this.dataSource = res.result
          if (this.dataSource) {
            this.approvers = this.dataSource.approver || []
            this.approvers.forEach(e => {
              e.userImg = `${hostImageUrlv3}/_/${e.emailOneId || e.email}`
            })
            this.token = this.dataSource.token
            this.serviceName = this.dataSource.serviceName
            this.note = this.dataSource.comment
            this.urlName = this.dataSource.url
            this.selectGroupCompany = this.dataSource.groupCompanyId
            await this.getCompanySelector()
            this.selectCompany = this.dataSource.companyId
            await this.getSectionSelector()
            if (this.dataSource.serviceForOrg.type === 'ทั้งหมด') {
              this.selectType = this.dataSource.serviceForOrg.type
              this.dataSource.serviceForOrg.orgId = ''
              this.selectOrgChart = ''
            } else {
              this.selectType = this.dataSource.serviceForOrg.type
              await this.getChartSelector()
              this.selectOrgChart = this.dataSource.serviceForOrg.orgId
            }
          } else {
            this.approvers = []
          }
          this.originDataSource = JSON.parse(JSON.stringify(this.dataSource))
        } else {
          this.dataSource = []
          this.approvers = []
        }
      } catch (error) {
        this.dataSource = []
        this.approvers = []
        console.log(error)
        swal('ผิดพลาด', 'เกิดข้อผิดพลาด', 'error', {
          button: false,
          timer: 2200
        }).then(() => {
          this.goBack()
        })
      } finally {
        this.loadingInit = false
        this.isInitData = false
      }
    },
    addApprover (approver) {
      // console.log(approver)
      const tempApprover = {
        approverId: approver._id,
        userId: approver.userId,
        approverName: approver.name,
        approverNo: this.approvers.length + 1,
        employeeId: approver.employeeId,
        position: approver.position.positionName,
        email: approver.emailOneId || approver.email,
        userImg: approver.userImg
      }
      this.approvers.push(tempApprover)
    },
    changeApprover (approverAndindex) {
      var approver = approverAndindex.approver
      var index = approverAndindex.index
      var approverTemp = this.approvers[index]
      const tempApprover = {
        approverId: approver._id,
        userId: approver.userId,
        approverName: approver.name,
        approverNo: index + 1,
        employeeId: approver.employeeId,
        position: approver.position.positionName,
        email: approver.email || approver.mailOneId,
        emailOneId: approver.emailOneId || '',
        userImg: approver.userImg
      }
      // this.approvers[index] = tempApprover
      Object.keys(tempApprover).forEach(function (key) {
        // this.approvers[index][key] = tempApprover[key]
        // console.log('key', tempApprover[key], approvers[index][key])
        approverTemp[key] = tempApprover[key]
      })
      // console.log('tempApprover', tempApprover)
    },
    async getGroupCompanySelector () {
      this.loading = true
      try {
        const res = await getSelectorGroup(this.$store.state.token)
        if (res.success) {
          this.itemGroupCompany = res.groupCompany || []
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getCompanySelector () {
      this.loading = true
      try {
        const res = await getSelectorGroup(this.$store.state.token, { groupCompanyId: this.selectGroupCompany })
        if (res.success) {
          this.itemCompany = res.company || []
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getSectionSelector () {
      this.loading = true
      const payload = {
        groupCompanyId: this.selectGroupCompany,
        companyId: this.selectCompany
      }
      try {
        const res = await getSelectorGroup(this.$store.state.token, payload)
        if (res.success) {
          this.sectionList = res.sectionList.map(({ name }) => (name))
          this.sectionNumberList = res.sectionList.map(({ section }) => (section))
        } else {
          this.sectionList = []
          this.sectionNumberList = []
        }
      } catch (error) {
        this.sectionList = []
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getChartSelector () {
      this.loading = true
      if (this.selectType === 'ทั้งหมด') {
        this.itemOrgChart = []
        this.loading = false
      } else {
        const payload = {
          groupCompanyId: this.selectGroupCompany,
          companyId: this.selectCompany,
          section: this.sectionNumberList[this.sectionList.indexOf(this.selectType)]
        }
        try {
          const res = await getSelectorGroup(this.$store.state.token, payload)
          if (res.success) {
            this.itemOrgChart = res.orgChart || []
          } else {
            this.itemOrgChart = []
          }
        } catch (error) {
          console.log(error)
          this.itemOrgChart = []
        } finally {
          this.loading = false
        }
      }
    },
    async getApproverlist (type) {
      var payload = { companyId: this.selectedCompany, orgChartType: type }
      const token = this.$store.state.token
      try {
        const res = await searchLeader(payload, token)
        if (res.success) {
          if (res.result.length) {
            this.itemLeaders = res.result
          }
        } else {
        }
      } catch (error) {
        this.itemLeaders = []
      } finally {
      }
    },
    goback () {
      this.$router.push('/settingservices')
    },
    onImgError (i) {
      this.approver[i].failed_image = true
    },
    pressSelectAll (objectname) {
      this.$nextTick(() => {
        if (this[`select${objectname}`].length === this[`item${objectname}`].length) {
          this[`select${objectname}`] = []
        } else {
          this[`select${objectname}`] = [...new Set(this[`item${objectname}`].map(x => x.id))]
        }
      })
    },
    openDialogAddAprover (action, item, index) {
      EventBus.$emit('openDialogAddAprover', true, item, action, index, this.alreadyUser)
    },
    async submitData () {
      if (!this.serviceName || !this.urlName || !this.note || !this.selectType || (this.selectType !== 'ทั้งหมด' && this.selectOrgChart === '')) {
        swal('Warning', 'กรุณากรอกข้อมูลให้ครบ', 'warning', {
          button: false,
          timer: 3000
        })
      } else if (this.approvers.length === 0) {
        swal('Warning', 'กรุณาเพิ่มผู้อนุมัติ', 'warning', {
          button: false,
          timer: 3000
        })
      } else {
        this.loading = true
        const obj = {
          serviceId: this.serviceId,
          groupCompanyId: this.selectGroupCompany,
          companyId: this.selectCompany,
          // serviceForOrg: {
          //   type: this.selectType === 'ทั้งหมด' ? 'ทั้งหมด' : this.selectType,
          //   orgId: this.selectType === 'ทั้งหมด' ? 'ทั้งหมด' : this.selectOrgChart
          // },
          serviceForOrg: {
            type: this.selectType,
            orgId: this.selectType === 'ทั้งหมด' ? 'ทั้งหมด' : this.selectOrgChart
          },
          serviceName: this.serviceName,
          comment: this.note,
          url: this.urlName,
          serviceType: '5f89295ed444d3a72e3b4260',
          approver: this.approvers
        }
        // console.log(obj)
        try {
          const res = await editService(obj, this.$store.state.token)
          if (res.success) {
            swal('สำเร็จ', 'บันทึก Service สำเร็จ', 'success', {
              button: false,
              timer: 2000
            })
            this.$router.go(-1)
          }
        } catch (error) {
          swal('ผิดพลาด', 'บันทึก Service ไม่สำเร็จ', 'error', {
            button: false,
            timer: 3000
          })
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    },
    checkRemove (item) {
      swal('ต้องการลบผู้อนุมัติคนนี้ ใช่หรือไม่!', {
        buttons: {
          cancel: 'ยกเลิก',
          catch: {
            text: 'ใช่',
            value: 'save'
          }
        }
      })
        .then((value) => {
          switch (value) {
            case 'save':
              this.removeApprover(item)
              break
          }
        })
    },
    removeApprover (item) {
      this.approvers.splice(this.approvers.indexOf(item), 1)
    },
    editApprover (item, index) {
      this.approver[this.approver.indexOf(item)] = {
        no: this.approver.indexOf(item),
        _id: item._id,
        employeeId: item.employeeId,
        nameTH: item.name,
        position: item.position,
        email: item.email || '',
        emailOneId: item.emailOneId || '',
        userImg: item.userImg
      }
    },
    hashCode (text) {
      // return s.split('').reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0)
      var hash = 0
      if (text.length === 0) return hash
      for (var i = 0; i < text.length; i++) {
        const char = text.charCodeAt(i)
        hash = ((hash << 5) - hash) + char
        hash = hash & hash // Convert to 32bit integer
      }
      return hash
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.base-image-input {
  display: block;
  width: 100px;
  height: 100px;
  /* padding: 8%; */
  border-radius: 5px;
  cursor: pointer;
  background-size: contain;
  background-position: center center;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.placeholder-image {
  /* background: #F0F0F0; */
  background-image: url('../../../assets/icons/no-company-7.png');
  width: 100%;
  height: 100%;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: 'Sarabun', sans-serif;
}
.placeholder:hover {
  /* background: #E0E0E0; */
  background-image: url('../../../assets/icons/no-company-7.png');

}
.file-input {
  display: none;
}
.box-image1 {
  border: 1px solid rgba(0, 0, 0, 0.4);
  outline: none;
  color: rgb(118, 118, 118);
  /* display: flex; */
  align-content: center;
  justify-content: center;
  display: grid;
  height: 70%;
  text-align: center;
}
.box-image2 {
  border: dashed;
  border-width: 1px 1px;
  border-radius: 10px;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
  display:none;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}

.show-service >>> .v-snack__wrapper {
  min-width: 10px !important;
}
</style>
